import React from "react";
import "./App.css";
import MultiStep from "./components/MultiStep";

function App() {
  return <MultiStep />;
}

export default App;
